import {GetSeferData} from "SeferPetach/GetData";

export async function getDesignationList() {
    var args = {};
    var payload = await GetSeferData("df1", args);
    return (payload);
}

export async function getDesignationByID(designation_id){
    var payload = await GetSeferData("df2", {'DESIGNATION_ID': designation_id});
    return (payload);
}

export async function updateDesignation(obj) {
    var payload = await GetSeferData("df3", obj);
    return (payload);
}

export async function deleteDesignation(designation_id){
    var payload = await GetSeferData("df4", {'DESIGNATION_ID': designation_id});
    return (payload);
}